<script setup>
import { ref, onMounted } from 'vue'
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  item: Object,
})

const guess = computed(() => props.item.enrichment?.guess)

const answerElement = ref(null)
const answerTextElement = ref(null)
const authorElement = ref(null)

const applyDynamicClamp = () => {
  const lineHeight = parseFloat(getComputedStyle(answerTextElement.value).lineHeight)
  const availableHeight = answerElement.value.clientHeight
  const lines = Math.floor(availableHeight / lineHeight)

  answerTextElement.value.style.webkitLineClamp = lines
}

onMounted(() => {
  applyDynamicClamp()

  gsapTimeline({ name: 'MysterySoundGuess' }).from(answerTextElement, { opacity: 0 }).from(authorElement, { opacity: 0 }, '<')
})

const { onDisappear } = useDisappearable()
onDisappear(() => gsapTimeline({ name: 'MysterySoundGuess - End' }).to(answerTextElement, { opacity: 0 }).to(authorElement, { opacity: 0 }, '<'))
</script>

<template>
  <div
    :style="{
      left: item.properties.position.xLeft + 'px',
      top: item.properties.position.yTop + 'px',
      fontSize: item.properties.position.fontSize + 'px',
      width: item.properties.position.width + 'px',
      height: item.properties.position.height + 'px',
    }"
    class="absolute flex flex-col font-cervo -tracking-[0.015em] text-center"
  >
    <div ref="answerElement" class="flex-1">
      <p ref="answerTextElement" class="overflow-hidden text-ellipsis text-q-cr-gray-primary font-bold leading-none text-center text-balance line-clamp-1">{{ guess.guess }}</p>
    </div>
    <div ref="authorElement" class="shrink-0 leading-none text-[.5em] text-q-cr-gray-primary font-bold">{{ guess.name }} uit {{ guess.place }}</div>
  </div>
</template>
